import { Box, Divider, Drawer, List } from '@mui/material';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from '@mantis-theme/config';
import { ReactNode } from 'react';
import AppLogo from '../branding/AppLogo';

interface SidebarDrawerProps {
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
  footerContent?: ReactNode;
  isMobileView: boolean;
}

export const SidebarDrawer = ({ open, onToggle, children, footerContent, isMobileView }: SidebarDrawerProps) => (
  <Drawer
    variant={isMobileView ? 'temporary' : 'permanent'}
    open={open}
    onClose={onToggle} // Close the drawer on click away or Esc key press
    ModalProps={{
      keepMounted: true,
      BackdropProps: {
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      },
    }}
    sx={{
      flexShrink: 0,
      ...(isMobileView
        ? {
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
            },
          }
        : {
            '& .MuiDrawer-paper': {
              width: open ? DRAWER_WIDTH : MINI_DRAWER_WIDTH,
              boxSizing: 'border-box',
              transition: 'width 0.3s ease',
              overflowX: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            },
          }),
    }}
  >
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 2,
          minHeight: 64,
        }}
      >
        <AppLogo size="medium" showText={open} variant="sidebar" onClick={onToggle} />
      </Box>
      <Divider />
    </Box>

    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto' }}>
        <List>{children}</List>
      </Box>

      {footerContent && (
        <Box
          sx={{
            flexShrink: 0,
            width: '100%',
            borderTop: '1px solid',
            borderColor: 'divider',
            py: 0.5,
            px: 1,
            '& > *': {
              margin: '4px 0',
            },
          }}
        >
          {footerContent}
        </Box>
      )}
    </Box>
  </Drawer>
);
